import { render, staticRenderFns } from "./AccountSelector.vue?vue&type=template&id=53c0cd62&"
import script from "./AccountSelector.vue?vue&type=script&lang=js&"
export * from "./AccountSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c0cd62')) {
      api.createRecord('53c0cd62', component.options)
    } else {
      api.reload('53c0cd62', component.options)
    }
    module.hot.accept("./AccountSelector.vue?vue&type=template&id=53c0cd62&", function () {
      api.rerender('53c0cd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/AccountSelector.vue"
export default component.exports